export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxzaGVldCUyMG1ldGFsJTIwZmFicmljYXRpb24lMjBpbmR1c3RyaWFsfGVufDB8fHx8MTc4NDI5Mzc1MXww&ixlib=rb-4.1.0&q=85",
  machining: "https://images.unsplash.com/photo-1666618090858-fbcee636bd3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxjbmMlMjBtYWNoaW5pbmclMjBwcmVjaXNpb258ZW58MHx8fHwxNzg0MjkzNzUxfDA&ixlib=rb-4.1.0&q=85",
  stamping: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMHN0YW1waW5nJTIwbWFjaGluZXJ5fGVufDB8fHx8MTc4NDI5Mzc1MXww&ixlib=rb-4.1.0&q=85",
  welding: "https://images.unsplash.com/photo-1564182842834-681b7be6de4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxzaGVldCUyMG1ldGFsJTIwZmFicmljYXRpb24lMjBpbmR1c3RyaWFsfGVufDB8fHx8MTc4NDI5Mzc1MXww&ixlib=rb-4.1.0&q=85",
  qualityRd: "https://images.unsplash.com/photo-1740209475472-aa7d280f7452?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxjbmMlMjBtYWNoaW5pbmclMjBwcmVjaXNpb258ZW58MHx8fHwxNzg0MjkzNzUxfDA&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "About", href: "#about" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Quality & R&D", href: "#quality" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  { id: "01", title: "Laser Cutting", desc: "High-precision CNC fiber laser cutting for sheet metal with clean, burr-free edges and intricate profiles." },
  { id: "02", title: "Plasma Cutting", desc: "High-speed CNC plasma cutting for thick metal plates and heavy-duty structural components." },
  { id: "03", title: "VMC / CNC Machining", desc: "Vertical machining centres and multi-axis CNC milling & turning for tight-tolerance precision parts." },
  { id: "04", title: "Press Shop", desc: "High-tonnage stamping, pressing, deep-draw and progressive-die operations for high-volume production." },
  { id: "05", title: "Rolling Machine", desc: "Plate and sheet rolling into cylinders, cones and curved sections for tanks, shells and fabrications." },
  { id: "06", title: "Robotic Welding", desc: "Automated robotic welding cells delivering consistent, high-speed, repeatable welds for volume production." },
  { id: "07", title: "Precision Welding", desc: "Expert MIG, TIG and spot welding for critical joints with clean, distortion-free, high-strength results." },
  { id: "08", title: "Shot Blasting", desc: "Surface preparation and cleaning via shot blasting to remove scale, rust and burrs for superior finish and coating adhesion." },
  { id: "09", title: "Powder Coating", desc: "Durable, corrosion-resistant powder coating in a wide range of colours and textures for a premium factory finish." },
  { id: "10", title: "Sheet Metal Toolings", desc: "In-house design and manufacture of press tools, dies and sheet-metal toolings for accurate, repeatable production." },
  { id: "11", title: "Welding Fixtures", desc: "Custom-engineered welding fixtures and jigs that ensure precise alignment and consistent weld quality at scale." },
];

export const STATS = [
  { value: "25+", label: "Years of Precision" },
  { value: "1.2M", label: "Components / Year" },
  { value: "±0.01", label: "mm Tolerance" },
  { value: "9", label: "Industries Served" },
];

export const CAPABILITIES = [
  {
    id: "01",
    title: "Sheet Metal Fabrication",
    desc: "Laser cutting, CNC bending, punching and forming of precision sheet metal enclosures and structural components.",
    image: IMAGES.welding,
    span: "lg:col-span-3 lg:row-span-2",
  },
  {
    id: "02",
    title: "Precision Stamping & Pressing",
    desc: "High-tonnage progressive and deep-draw stamping for high-volume metal components.",
    image: IMAGES.stamping,
    span: "lg:col-span-3",
  },
  {
    id: "03",
    title: "CNC Machining",
    desc: "Multi-axis milling and turning with tight tolerances and repeatable finish quality.",
    image: IMAGES.machining,
    span: "lg:col-span-3",
  },
  {
    id: "04",
    title: "R&D & Prototyping",
    desc: "Design-for-manufacture engineering, rapid tooling and validated prototypes.",
    image: IMAGES.qualityRd,
    span: "lg:col-span-6",
  },
];

export const INDUSTRIES = [
  "Automotive",
  "Aerospace & Defense",
  "Energy & Power",
  "Electrical & Electronics",
  "Telecommunications",
  "Industrial Machinery",
  "Railways",
  "Medical Equipment",
  "Renewables",
];

export const MANIFESTO = [
  {
    id: "01",
    title: "Engineering First",
    desc: "Every component begins in our R&D lab. Simulation, DFM analysis and tooling design de-risk production before a single sheet is cut.",
  },
  {
    id: "02",
    title: "Certified Quality",
    desc: "ISO 9001:2015 certified processes, CMM inspection labs and full material traceability on every batch we ship.",
  },
  {
    id: "03",
    title: "Zero-Defect Mindset",
    desc: "In-line inspection, statistical process control and PPAP documentation deliver consistent, audit-ready quality.",
  },
  {
    id: "04",
    title: "Built To Scale",
    desc: "From single prototypes to million-unit runs, our automated cells and tooling capacity flex to your volume.",
  },
];

export const COMPANY = {
  name: "Techno Stamping & Pressing Industries",
  short: "Techno Stamping",
  tagline: "Precision. Power. Performance.",
  email: "info@technostamping.com",
  phone: "9386819589",
  address: "N.S 42, Industrial Area, Adityapur, Jamshedpur, Seraikela Kharsawan, Jharkhand 832109, India",
  services: [
    "Laser Cutting",
    "Plasma Cutting",
    "VMC / CNC Machining",
    "Press Shop",
    "Rolling Machine",
    "Robotic Welding",
    "Precision Welding",
    "Shot Blasting",
    "Powder Coating",
    "Sheet Metal Toolings",
    "Welding Fixtures",
    "General Inquiry",
  ],
};
